// ABOUTME: The forgive dissolve's timings and the hook that says whether the storm is still drawn and fading.
// ABOUTME: Arriving already forgiven plays nothing; only becoming forgiven on the same screen fades, and reduced motion skips it.

import { useEffect, useState } from 'react';
import { useCrossingReducedMotion } from '../../crossing/useReducedMotion';

// The sky mask and the rain fade out together over this long (the prototype's rcvGlowOp).
export const DISSOLVE_SEC = 1.6;
// The stack's tiers and bridge lobes come up to their lit colours over this long (the prototype's rcvStarFade).
export const LIGHTEN_SEC = 0.9;

export interface StormDissolve {
  present: boolean; // the storm layers are still drawn (they stay for the fade, then go)
  fading: boolean; // they are drawn on the way out
  pressed: boolean; // the crossing became forgiven on this screen, not before it
}

// `scope` names the screen the flag is read on: a component that outlives screen changes passes it, so a forgiven
// screen it moves onto counts as an arrival rather than a press.
export function useStormDissolve(forgiven: boolean, scope = ''): StormDissolve {
  const reducedMotion = useCrossingReducedMotion();
  const [seen, setSeen] = useState({ scope, forgiven, pressed: false });
  const [finished, setFinished] = useState(false);

  let current = seen;
  if (seen.scope !== scope || seen.forgiven !== forgiven) {
    current = { scope, forgiven, pressed: seen.scope === scope && !seen.forgiven && forgiven };
    setSeen(current);
    setFinished(false);
  }

  const { pressed } = current;
  useEffect(() => {
    if (!pressed || reducedMotion) return undefined;
    const timer = setTimeout(() => setFinished(true), DISSOLVE_SEC * 1000);
    return () => clearTimeout(timer);
  }, [pressed, reducedMotion, scope]);

  const present = !forgiven || (pressed && !reducedMotion && !finished);
  return { present, fading: forgiven && present, pressed };
}
